module.exports = __webpack_public_path__ + "media/images/icon_level_white-840c15184ba1fac5fee3e97bb4faa8f0.png";